import React from 'react';
import * as FaIcons from 'react-icons/fa';


function NavBar() {
    return (
        <div className="navbar">
                <a href="/"><FaIcons.FaBars/></a>
        </div>
    )
}

export default NavBar
